export default __webpack_public_path__ + "static/media/hightlight1.bd5c367a.png";